import React from 'react'
import { t } from 'i18next'
import { SelectCheckSC } from '../select-next-check/select-next-check.styled'
import Select from '@hilbi/web-common/components/select'
import { TActionType } from '../../reducers/addRecordReducer'
import useRiskCategories from '../../hooks/useGetRiskCategories'

export type TProgramType = '1' | '2' | '3' | '4' | '5'

interface ISelectProgramTypeProps {
  dispatch: React.Dispatch<TActionType>
  dropdownValue: string | null
}

const SelectProgramType = ({ dispatch, dropdownValue }: ISelectProgramTypeProps) => {
  const { data: riskCategories } = useRiskCategories()

  const handleSelectChange = (e: { value: string; label: string }) => {
    dispatch({ type: 'ADD_PROGRAM_TYPE_CHANGE', payload: e.value })
  }

  const options = riskCategories?.map((cat) => ({
    value: cat.id,
    label: t(`addRunningCycleRecord.programType.${cat.risk}`),
  }))

  return (
    <SelectCheckSC>
      <Select
        value={options?.filter((option) => option.value === dropdownValue)}
        options={options}
        variation='underline'
        multi={false}
        onChange={handleSelectChange}
        placeholder={t('addRunningCycleRecord.programType.placeholder')}
        id='program-type'
      />
    </SelectCheckSC>
  )
}

export default SelectProgramType
